import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireLocalforage } from '../node_modules/.pnpm/localforage@1.10.0/node_modules/localforage/dist/localforage.js';

var localforageExports = requireLocalforage();
const localforage = /*@__PURE__*/getDefaultExportFromCjs(localforageExports);

export { localforage as default };
//# sourceMappingURL=localforage.js.map
